import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "draft_svg__surface1" }, [
      _createElementVNode("path", {
        style: {"stroke":"none","fill-rule":"nonzero","fill-opacity":"1"},
        d: "M 6.308594 21.5 C 5.800781 21.5 5.375 21.324219 5.023438 20.976562 C 4.675781 20.625 4.5 20.199219 4.5 19.691406 L 4.5 4.308594 C 4.5 3.800781 4.675781 3.375 5.023438 3.023438 C 5.375 2.675781 5.800781 2.5 6.308594 2.5 L 14.25 2.5 L 19.5 7.75 L 19.5 19.691406 C 19.5 20.199219 19.324219 20.625 18.976562 20.976562 C 18.625 21.324219 18.199219 21.5 17.691406 21.5 Z M 13.5 8.5 L 13.5 4 L 6.308594 4 C 6.230469 4 6.160156 4.03125 6.097656 4.097656 C 6.03125 4.160156 6 4.230469 6 4.308594 L 6 19.691406 C 6 19.769531 6.03125 19.839844 6.097656 19.902344 C 6.160156 19.96875 6.230469 20 6.308594 20 L 17.691406 20 C 17.769531 20 17.839844 19.96875 17.902344 19.902344 C 17.96875 19.839844 18 19.769531 18 19.691406 L 18 8.5 Z M 6 4 L 6 8.5 L 6 4 L 6 20 Z M 6 4 "
      })
    ], -1)
  ]))]))
}
export default { render: render }